/**
 * Google's mark, the same four paths the console has always drawn.
 *
 * It was inlined in the Worker as `GOOGLE_G` and did not survive the flip to a
 * single-page app: the button kept its words and lost its logo, which is the
 * kind of difference a test never has an opinion about and an eye sees at once
 * (found by comparing screenshots against production, review of #8).
 *
 * `aria-hidden` because the button already says "Continue with Google" — a
 * screen reader announcing the brand twice is worse than not at all.
 */
export function GoogleMark() {
  return (
    <svg className="inline-block size-[18px] align-middle" viewBox="0 0 48 48" aria-hidden="true">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35 24 35c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.5-8 19.5-20 0-1.3-.1-2.3-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.3 34.9 26.8 36 24 36c-5.3 0-9.7-2.6-11.3-6.9l-6.5 5C9.6 39.6 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.4 36 43.5 30.6 43.5 24c0-1.2-.1-2.3-.4-3.5z"
      />
    </svg>
  );
}
